import callApiAxiosClient from '../../axios/axios_client';
import { polygonObjectList } from '../../models';

async function modifyTrainingDetectionregions(imageId: number, polygons: polygonObjectList): Promise<void> {
  const token = JSON.parse(localStorage.getItem('user')!);
  const authorization = 'Bearer ' + token.token;
  return callApiAxiosClient({
    method: 'put',
    url: 'training/detection-region',
    headers: {
      'Content-Type': 'Application/json',
      Authorization: authorization,
    },
    data: {
      image_id: imageId,
      polygons: polygons,
    },
  });
}

export default modifyTrainingDetectionregions;
